<template>
  <div
    class="page--usagepolicypage"
    :style="`min-height: ${height}px`"
  >
    <Header
      :kind="routeParams.type"
      :status="currentStatus"
    />

    <Form
      :kind="routeParams.type"
      :submit="submitForm"
      :data="usagePolicyData"
      :status="currentStatus"
      @tryAgain="getUsagePolicyById"
      @setCurrentStatus="setCurrentStatus"
    />

    <Footer
      v-if="hasRole('timePolicy', 'ROLE_POST_TIMEPOLICY') || hasRole('timePolicy', 'ROLE_PUT_TIMEPOLICY_TIMEPOLICYID')"
      :kind="routeParams.type"
      :status="currentStatus"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { hasRole, isArray } from 'utils/functions'
import { getTimePolicyType } from 'utils/timePolicy'
import Header from 'components/usagePolicy/Header'
import Form from 'components/usagePolicy/Form'
import Footer from 'components/usagePolicy/Footer'

export default {
  name: 'UsagePolicyPage',
  components: {
    Header,
    Form,
    Footer
  },
  computed: {
    routeParams () {
      return this.$route.params
    },

    height () {
      return document.body.offsetHeight
    },

    policyId () {
      return this.routeParams.id ? Number(this.routeParams.id) : null
    }
  },
  data () {
    return {
      namespace: 'Views.UsagePolicyPage',
      submitForm: false,
      usagePolicyData: null,
      currentStatus: null
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    isValidArray (val) {
      return isArray(val)
    },

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    hasDuplicates (array) {
      let valuesSoFar = Object.create(null)

      for (let i = 0; i < array.length; ++i) {
        const value = array[i]
        if (value in valuesSoFar) return true
        valuesSoFar[value] = true
      }

      return false
    },

    // getTimePolicyType (intervals) {
    //   const intervalsOrdened = intervals.sort((a, b) => {
    //     if (a.dayOfWeek < b.dayOfWeek) return -1
    //     if (a.dayOfWeek > b.dayOfWeek) return 1
    //     return 0
    //   })

    //   const hasWeekendDays = intervalsOrdened.some(interval => interval.dayOfWeek === 0 || interval.dayOfWeek === 6)
    //   const intervalsArray = intervalsOrdened.map(interval => {
    //     const key = `${interval.startTime}-${interval.endTime}`
    //     return { key, ...interval }
    //   })

    //   const dayOfWeekArray = removeDuplicateItemsInArray(intervalsArray.map(interval => interval.key))
    //   const intervalsGroup = dayOfWeekArray.map(key => {
    //     const intervals = intervalsArray.filter(i => i.key === key)
    //     const startTime = intervals[0].startTime
    //     const endTime = intervals[0].endTime
    //     const daysOfWeek = intervals.map(i => i.dayOfWeek)

    //     return {
    //       key,
    //       daysOfWeek,
    //       startTime,
    //       endTime
    //     }
    //   })

    //   const isWorkingDays = intervalsGroup.every(interval => (
    //     interval.daysOfWeek.length === 5 &&
    //     interval.daysOfWeek[0] === 1 &&
    //     interval.daysOfWeek[interval.daysOfWeek.length - 1] === 5
    //   ))

    //   if (isWorkingDays && !hasWeekendDays) {
    //     return 'workingDays'
    //   }

    //   return 'customDays'
    // },

    renderPayload ({ timePolicy, costCenter }) {
      const timePolicyType = timePolicy && timePolicy.intervals
        ? getTimePolicyType(timePolicy.intervals)
        : null

      return {
        timePolicyType,
        timePolicy,
        costCenter
      }
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    async getTimePolicyById () {
      try {
        const { data: res } = await this.$apiService.getTimePolicyById(this.policyId)
        return res && res.data ? { timePolicy: res.data } : {}
      } catch (err) {
        if (err && err.response && err.response.status && err.response.status === 404) {
          this.$router.push({ name: 'UsagePolicies' })
        }
      }
    },

    async getCostCenterTimePolicyById () {
      try {
        const { data: res } = await this.$apiService.getCostCenterTimePolicyById(this.policyId)
        return res && res.data ? { costCenter: res.data } : {}
      } catch (err) {
        if (err && err.response && err.response.status && err.response.status === 404) {
          this.$router.push({ name: 'UsagePolicies' })
        }
      }
    },

    async getUsagePolicyById () {
      if (this.routeParams.type === 'editar') {
        this.currentStatus = STATUS_IS_LOADING

        try {
          const [timePolicy = {}, costCenter = {}] = await Promise.all([
            this.getTimePolicyById(),
            this.getCostCenterTimePolicyById()
          ])

          this.usagePolicyData = this.renderPayload({ ...timePolicy, ...costCenter })
          this.currentStatus = STATUS_SUCCESS
        } catch (err) {
          console.log('ERROR:', err)
          this.currentStatus = STATUS_FAILED
        }
      }
    }
  },
  watch: {
    'routeParams.id' () {
      location.reload()
    }
  },
  beforeMount () {
    if (this.routeParams.type !== 'cadastrar' && this.routeParams.type !== 'editar') {
      this.$router.push({ name: 'UsagePolicies' })
    }
  },
  mounted () {
    this.getUsagePolicyById()

    if (this.routeParams.type !== 'editar') {
      this.currentStatus = STATUS_SUCCESS
    }

    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
